module.exports = __webpack_public_path__ + "static/img/pinHeader-1.620d1a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/pinHeader-1.svg
// module id = RFgz
// module chunks = 0